/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import Switch from 'react-switch'
import Select from 'react-select'
import {
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Alert,
} from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import { isComma } from 'context/Utilities'

const SubmittedProductDescReview = ({ item, isDisabled }) => {
  const methods = useFormContext()

  const {
    onChangeReviewer,
    setSwitchReviewer,
    setSelectReviewer,
    asterisk,
  } = useFormUtils()

  const [description, setDescription] = useState({
    UPC: '',
    BrandName: '',
    ProductName: '',
    Manufacturer: '',
    ProductDesc: '',
    ExchangeSize: '',
    UoM: '',
    IsBroadband: true,
    DistbInCA: false,
    RetailPrice: 0.0,
    FederalNutrition: false,
    ReviewerDescription: '',
    isBrandSpecific: false,
  })

  useEffect(() => {
    if (item) {
      console.log('item is: ' + JSON.stringify(item))
      const {
        UPC,
        BrandName,
        ProductName,
        Manufacturer,
        ProductDesc,
        ExchangeSize,
        UoM,
        IsBroadband,
        DistbInCA,
        RetailPrice,
        FederalNutrition,
        ReviewerDescription,
        isBrandSpecific,
      } = item
      setDescription({
        UPC: UPC ?? '',
        BrandName: BrandName ?? '',
        ProductName: ProductName ?? '',
        Manufacturer: Manufacturer ?? '',
        ProductDesc: ProductDesc ?? '',
        ExchangeSize: ExchangeSize ?? '',
        UoM: UoM ?? '',
        IsBroadband: IsBroadband ?? '',
        DistbInCA: DistbInCA ?? false,
        RetailPrice: RetailPrice,
        FederalNutrition: FederalNutrition ?? false,
        ReviewerDescription: ReviewerDescription ?? '',
        isBrandSpecific: isBrandSpecific ?? false,
      })
      methods.reset({
        UPC: UPC,
        BrandName: BrandName,
        ProductName: ProductName,
        Manufacturer: Manufacturer,
        ProductDesc: ProductDesc,
        ExchangeSize: ExchangeSize,
        UoM: { value: UoM, label: UoM },
        DistbInCA: DistbInCA,
        RetailPrice: RetailPrice,
        FederalNutrition: FederalNutrition,
        ReviewerDescription: ReviewerDescription,
      })
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item])

  const UoMOptions = [
    {
      value: '',
      label: 'UOM',
      isDisabled: true,
    },
    {
      value: '$$$',
      label: '$$$',
    },
    {
      value: 'CAN',
      label: 'CAN',
    },
    {
      value: 'CTR',
      label: 'CTR',
    },
    {
      value: 'DOZ',
      label: 'DOZ',
    },
    {
      value: 'GAL',
      label: 'GAL',
    },
    {
      value: 'OZ',
      label: 'OZ',
    },
    {
      value: 'BTL',
      label: 'BTL',
    },
  ]

  return (
    <div>
      <Row>
        <Col xs={2}>
          <FormGroup>
            <strong>UPC {asterisk}</strong>
            <Controller
              as={Input}
              name="UPC"
              control={methods.control}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              onKeyDown={e => {
                if (
                  ![
                    'Backspace',
                    'Delete',
                    'Tab',
                    'ArrowLeft',
                    'ArrowRight',
                  ].includes(e.key) &&
                  isNaN(parseInt(e.key))
                ) {
                  e.preventDefault()
                }
              }}
              rules={{
                required: true,
                pattern: /[\d]+/,
                validate: {
                  length: UPC => [8, 12, 13].includes(UPC.length),
                  allZeros: UPC =>
                    !['00000000', '000000000000', '0000000000000'].includes(
                      UPC
                    ),
                },
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              {methods.errors.UPC && methods.errors.UPC.type === 'required' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ UPC is required.
                </Alert>
              )}
              {methods.errors.UPC && methods.errors.UPC.type === 'length' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ UPC must be 8, 12, or 13 digits.
                </Alert>
              )}
              {methods.errors.UPC && methods.errors.UPC.type === 'allZeros' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ UPC must not consist of all zeros.
                </Alert>
              )}
            </p>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>Manufacturer</strong>
            <Controller
              as={Input}
              name="Manufacturer"
              control={methods.control}
              onKeyDown={e => {
                if (isComma(e.key)) {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              rules={{
                maxLength: 20,
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              {methods.errors.Manufacturer &&
                methods.errors.Manufacturer.type === 'maxLength' && (
                  <Alert color="danger" className={'mt-3'}>
                    ⚠ Manufacturer exceeds 20 characters.
                  </Alert>
                )}
            </p>
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <strong>Brand Name {asterisk}</strong>
            <Controller
              as={Input}
              name="BrandName"
              control={methods.control}
              onKeyDown={e => {
                if (isComma(e.key)) {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              rules={{
                required: true,
                maxLength: 50,
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              {methods.errors.BrandName &&
                methods.errors.BrandName.type === 'required' && (
                  <Alert color="danger" className={'mt-3'}>
                    ⚠ Brand name is required.
                  </Alert>
                )}
              {methods.errors.BrandName &&
                methods.errors.BrandName.type === 'maxLength' && (
                  <Alert color="danger" className={'mt-3'}>
                    ⚠ Brand name exceeds 50 characters.
                  </Alert>
                )}
            </p>
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <strong>Product Name {asterisk}</strong>
            <Controller
              as={Input}
              name="ProductName"
              control={methods.control}
              onKeyDown={e => {
                if (isComma(e.key)) {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              rules={{
                required: true,
                maxLength: 50,
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              {methods.errors.ProductName &&
                methods.errors.ProductName.type === 'required' && (
                  <Alert color="danger" className={'mt-3'}>
                    ⚠ Product name is required.
                  </Alert>
                )}
              {methods.errors.ProductName &&
                methods.errors.ProductName.type === 'maxLength' && (
                  <Alert color="danger" className={'mt-3'}>
                    ⚠ Product name exceeds 50 characters.
                  </Alert>
                )}
            </p>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>Distributed in California {asterisk}</strong>
            <br />
            <Controller
              as={Switch}
              name="DistbInCA"
              id="DistbInCA"
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              defaultValue={description.DistbInCA}
              rules={{ validate: DistbInCA => DistbInCA === true }}
              disabled={isDisabled}
            />
            <br />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="DistbInCA"
                message={'⚠ Product must be distributed in CA.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          <FormGroup>
            <strong>
              Suggested Retail Price Per Unit {item.isBrandSpecific && asterisk}
            </strong>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>$</InputGroupText>
              </InputGroupAddon>
              <Controller
                as={Input}
                name="RetailPrice"
                type="number"
                max="999.99"
                step=".01"
                control={methods.control}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                onKeyDown={e => {
                  if (
                    ![
                      'Backspace',
                      'Delete',
                      'Tab',
                      '.',
                      'ArrowLeft',
                      'ArrowRight',
                    ].includes(e.key) &&
                    isNaN(parseInt(e.key))
                  ) {
                    e.preventDefault()
                  }
                }}
                placeholder={'Retail Price'}
                rules={{
                  maxLength: 6,
                  validate: value => {
                    if (item.isBrandSpecific) {
                      return value > 0 || 'Price must be greater than 0'
                    }
                    return true
                  },
                  required: item.isBrandSpecific,
                }}
                disabled={isDisabled}
              />
            </InputGroup>
            <p className={'text-danger'}>
              {methods.errors.RetailPrice &&
                methods.errors.RetailPrice.type === 'maxLength' && (
                  <Alert color="danger" className={'mt-3'}>
                    ⚠ Retail price exceeds 6 characters.
                  </Alert>
                )}
              {methods.errors.RetailPrice &&
                methods.errors.RetailPrice.type === 'validate' && (
                  <Alert color="danger" className={'mt-3'}>
                    ⚠ Retail price must be greater than 0.
                  </Alert>
                )}
              {methods.errors.RetailPrice &&
                methods.errors.RetailPrice.type === 'required' && (
                  <Alert color="danger" className={'mt-3'}>
                    ⚠ Retail Price is required.
                  </Alert>
                )}
            </p>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>APL Description</strong>
            <Controller
              as={Input}
              name="ReviewerDescription"
              placeholder={'Max 25 characters'}
              control={methods.control}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              rules={{
                maxLength: {
                  value: 25,
                  message: '⚠ APL description exceeds 25 characters.',
                },
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="ReviewerDescription"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <strong>Product Description</strong>
            <Controller
              as={Input}
              name="ProductDesc"
              placeholder={'Max 50 characters'}
              control={methods.control}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              rules={{
                maxLength: {
                  value: 50,
                  message: '⚠ Product Description exceeds 50 characters.',
                },
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="ProductDesc"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={1}>
          <FormGroup>
            <strong>Exchange Size</strong>
            <Controller
              as={Input}
              name="ExchangeSize"
              control={methods.control}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              onKeyDown={e => {
                if (
                  ![
                    'Backspace',
                    'Delete',
                    'Tab',
                    '.',
                    'ArrowLeft',
                    'ArrowRight',
                  ].includes(e.key) &&
                  isNaN(parseInt(e.key))
                ) {
                  e.preventDefault()
                }
              }}
              rules={{
                maxLength: {
                  value: 6,
                  message: '⚠ Exchange Size exceeds 6 characters.',
                },
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="ExchangeSize"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>UOM</strong>
            <br />
            <Controller
              as={Select}
              className="react-select primary"
              classNamePrefix="react-select"
              options={UoMOptions}
              name="UoM"
              control={methods.control}
              placeholder={'UoM'}
              onChange={([selected, value]) => {
                setSelectReviewer(item, selected, value)
                methods.clearError('UoM')
                return selected
              }}
              isDisabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="UoM"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>Federal Nutrition {asterisk}</strong>
            <br />
            <Controller
              as={Switch}
              name="FederalNutrition"
              id="FederalNutrition"
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              defaultValue={description.FederalNutrition}
              rules={{
                validate: FederalNutrition => FederalNutrition === true,
              }}
              disabled={isDisabled}
            />
            <br />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="FederalNutrition"
                message={'⚠ Product must meet federal nutrition levels.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
      </Row>
    </div>
  )
}

export default SubmittedProductDescReview
